'use strict';
module.exports = Math.log10 || function (x) {
	return Math.log(x) * Math.LOG10E;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/log10/index.js
// module id = guXG
// module chunks = 0